import Swiper from "swiper/bundle";
import "swiper/css";

const restaurantSwiperElement = document.querySelector(".js-restaurant");
if (restaurantSwiperElement) {
  //スマホ用ページネーションの幅を計算
  // ①横幅の設定
  const paginationWidth = 240;
  // ② 「.swiper-wrapper」の要素の数を取得
  const wrapperElementsCount = document.querySelectorAll(
    ".p-restaurant-topics__list .swiper-slide"
  ).length;
  // ③ ① ÷ ② の結果を求める
  const bulletWidth = paginationWidth / wrapperElementsCount;
  let bulletWidth_span = bulletWidth;

  const mySwiper = new Swiper(restaurantSwiperElement, {
    loop: true,
    loopAdditionalSlides: 3,
    spaceBetween: 9,
    slidesPerView: 2.2,
    observer: true,
    observeParents: true,
    pagination: {
      el: ".restaurant-swiper-pagination",
      renderBullet(index, className) {
        return (
          '<span class="' +
          className +
          '" style="width:' +
          bulletWidth_span +
          'px"></span>'
        );
      },
    },
    on: {
      init() {
        updateExtraPagination(this);
      },
      slideChange() {
        updateExtraPagination(this);
      },
    },

    breakpoints: {
      769: {
        spaceBetween: 35,
        slidesPerView: 3,
        navigation: {
          nextEl: ".restaurant-swiper-next",
          prevEl: ".restaurant-swiper-prev",
        },
        scrollbar: {
          el: ".restaurant-swiper-scrollbar",
          draggable: false,
          lockClass: "swiper-scrollbar-lock",
        },
      },
    },
  });

  function updateExtraPagination(swiper) {
    const paginationElement = document.querySelector(
      ".restaurant-swiper-pagination-extra"
    );
    if (paginationElement) {
      const currentIndex = swiper.realIndex + 1;
      const totalSlides = swiper.slides.length;
      paginationElement.innerHTML =
        ("00" + currentIndex).slice(-2) +
        "<span> | </span>" +
        ("00" + totalSlides).slice(-2);
    } else {
      console.warn(".restaurant-swiper-pagination-extra が見つかりません。");
    }
  }
}
